import './DataTableGanttAnnotationsIndicators.css';
export var annotationIndicators = '_1x1hmrh0-3-8-0';